import PrivacyPolicy from "@/features/privacy-policy";

const PrivacyPolicyPage = () => {
  return <PrivacyPolicy />;
};

export default PrivacyPolicyPage;
